import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import TransomConfigurator from './../TransomConfigurator';
import Disclaimer from '../Disclaimer';
import RadioGroup from './../RadioGroup';
import { withTranslation, Trans } from 'react-i18next';
import { view012ImageOptions } from './views/view012'


class Sternanchor extends Component {
    constructor(props) {
        super(props);
		this.handleAnchorSternChange = this.handleAnchorSternChange.bind(this);
	}

	handleAnchorSternChange(newValue) {
		let configuration = this.props.configuration;
		configuration.AnchorStern = newValue;

		if (this.props.onChange) {
			this.props.onChange(configuration);
		}
	}

    render() {
		let imageOptions = view012ImageOptions;

        let image = (
			<TransomConfigurator colorMultiplier={0.50} name={this.props.transom.Name} port={this.props.transom.Port} transomSize={{ width: 930, height: 225 }} transform={
				[
					0.127055, 0.055809, 0, -0.000098,
					0.04446, 0.319885, 0, 0.0001,
					0, 0, 1, 0,
					400, 109, 0, 1
				]}>
				<ConfiguratorImage boat="Xpower" configuration={this.props.configuration} options={imageOptions} />
			</TransomConfigurator>

        );

        return (
            <ConfiguratorSection image={image}>

                <ConfiguratorOption style={{ position: 'relative' }}>

					<h1><Trans defaults='Anchor' /></h1>
					<h2><Trans defaults='Stern' /></h2>

					<RadioGroup options={this.props.AnchorSternOptions} value={this.props.configuration.AnchorStern} onChange={this.handleAnchorSternChange} />

                    <Disclaimer />


                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(Sternanchor);


// WEBPACK FOOTER //
// ./src/Xpower/Sternanchor.js